/*
 * The Belgian Brewer: "Two places to drink it" (sections/tbb-visit.liquid).
 * Dogs of Epping: native scroll-snap does the swiping (and arrow keys when the strip has focus);
 * the brass buttons move one screenful of dogs at a time, and the counter and progress rule follow.
 * Nothing moves on its own.
 */
const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function setUpDogs(root) {
  if (root.dataset.tbbReady) return;
  root.dataset.tbbReady = 'true';

  const track = root.querySelector('[data-tbb-dogs-track]');
  const prev = root.querySelector('[data-tbb-dogs-prev]');
  const next = root.querySelector('[data-tbb-dogs-next]');
  const from = root.querySelector('[data-tbb-dogs-from]');
  const to = root.querySelector('[data-tbb-dogs-to]');
  const thumb = root.querySelector('[data-tbb-dogs-thumb]');
  const dogs = track?.children;
  if (!track || !dogs?.length) return;
  const total = dogs.length;

  const measure = () => {
    const w = dogs[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return { w, gap, per: Math.max(1, Math.floor((track.clientWidth + gap * 0.5) / (w + gap))) };
  };

  const go = (direction) => {
    const m = measure();
    track.scrollBy({ left: direction * m.per * (m.w + m.gap), behavior: reduceMotion() ? 'auto' : 'smooth' });
  };

  prev.addEventListener('click', () => {
    if (prev.getAttribute('aria-disabled') !== 'true') go(-1);
  });
  next.addEventListener('click', () => {
    if (next.getAttribute('aria-disabled') !== 'true') go(1);
  });

  let frame = 0;
  const update = () => {
    frame = 0;
    const m = measure();
    const x = track.scrollLeft;
    const max = track.scrollWidth - track.clientWidth;
    const atEnd = x >= max - 2;
    let first = Math.min(total, Math.round(x / (m.w + m.gap)) + 1);
    if (atEnd) first = Math.max(1, total - m.per + 1);
    from.textContent = first;
    to.textContent = Math.min(total, first + m.per - 1);
    prev.setAttribute('aria-disabled', String(x <= 2));
    next.setAttribute('aria-disabled', String(atEnd));

    const fraction = Math.min(1, track.clientWidth / track.scrollWidth);
    const railWidth = thumb.parentNode.clientWidth;
    thumb.style.width = `${fraction * 100}%`;
    thumb.style.transform = `translateX(${(max > 0 ? (x / max) * railWidth * (1 - fraction) : 0).toFixed(1)}px)`;
  };

  track.addEventListener(
    'scroll',
    () => {
      if (!frame) frame = requestAnimationFrame(update);
    },
    { passive: true }
  );
  if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
  else window.addEventListener('resize', update);
  update();
}

const init = (root = document) => root.querySelectorAll('[data-tbb-dogs]').forEach(setUpDogs);
init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
